/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useRef } from 'react';
import { DataTable, DataTableFilterEvent, DataTablePageEvent, DataTableStateEvent } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Card } from 'primereact/card';
import { Toast } from 'primereact/toast';
import { InputText } from 'primereact/inputtext';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { StyleService } from '../../service/StyleService';
import Style from '../../models/Style';
import { Link } from 'react-router-dom';
import StyleList from '../../models/StyleList';
import { Checkbox, CheckboxChangeEvent } from 'primereact/checkbox';
import StyleLazyState from '../../models/StyleLazyState';

const Styles = () => {
    let initialLazyState: StyleLazyState | DataTablePageEvent | DataTableFilterEvent = {
        currentPageNumber: 0,
        firstRow: 0,
        lastRow: 0,
        first: 0,
        rows: 25,
        page: 0,
        filter: null,
        isMissingBom: false,
        isMissingSetup: false
    };

    const [lazyState, setLazyState] = useState<StyleLazyState | DataTablePageEvent | DataTableFilterEvent>(initialLazyState);

    const [totalStyles, setTotalStyles] = useState(0);
    const [currentPageNumber, setPageNumber] = useState(0);
    const [firstIdNumber, setFirstIdNumber] = useState(0);
    const [lastIdNumber, setLastIdNumber] = useState(0);
    const [styles, setStyles] = useState<Style[]>([]);
    const [loadingBillOfMaterialStyles, setLoadingBillOfMaterialStyles] = useState(true);
    const [globalFilter, setGlobalFilter] = useState<string | null>(null);
    const [debouncedFilter, setDebouncedFilter] = useState(globalFilter);
    const [sortField, setSortField] = useState<string>('');
    const [sortOrder, setSortOrder] = useState<0 | 1 | -1 | null | undefined>(null);
    const [isMissingSetup, setIsMissingSetup] = useState<boolean>(false);
    const [isMissingBom, setIsMissingBom] = useState<boolean>(false);
    const toast = useRef<any>(null);
    const refStyleCode = useRef<any>(null);

    useEffect(() => {
        !loadingBillOfMaterialStyles && setLoadingBillOfMaterialStyles(true);
        getStyles();

        if (sessionStorage.getItem('lastStyleCode') !== null || sessionStorage.getItem('lastStyleCode') !== '') {
            refStyleCode.current.value = sessionStorage.getItem('lastStyleCode');
        };
    }, [lazyState, sortOrder]);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedFilter(globalFilter);
        }, 700);

        return () => {
            clearTimeout(handler);
        };
    }, [globalFilter]);

    useEffect(() => {
        console.log('Calling API with:', debouncedFilter);
        sessionStorage.setItem('lastStyleCode', debouncedFilter || '');
        if (globalFilter === '') {
            setLazyState(initialLazyState);
        }
    }, [debouncedFilter]);

    const getStyles = () => {
        let _lazyState = { ...lazyState };
        _lazyState.currentPageNumber = currentPageNumber;
        _lazyState.firstRow = firstIdNumber;
        _lazyState.lastRow = lastIdNumber;
        _lazyState.filter = sessionStorage.getItem('lastStyleCode');
        _lazyState.sortField = sortField;
        _lazyState.sortOrder = sortOrder;
        setPageNumber(_lazyState.page);

        StyleService.getStylesLazy(_lazyState).then((data: StyleList) => {
            if (data.totalRecords > 0) {
                setStyles(data.styles);
                setFirstIdNumber(data.styles[0].rowNumber);
                let _lastOrder = [...data.styles].pop();
                if(_lastOrder){
                    setLastIdNumber(_lastOrder.rowNumber);
                    setTotalStyles(data.totalRecords);
                    setLoadingBillOfMaterialStyles(false);
                }
            } else {
                setStyles([]);
                setFirstIdNumber(0);
                setLastIdNumber(0);
                setTotalStyles(0);
                setLoadingBillOfMaterialStyles(false);
            }
        });
    }

    const onPage = (event: DataTablePageEvent) => {
        event['filter'] = globalFilter;
        event['isMissingSetup'] = isMissingSetup;
        event['isMissingBom'] = isMissingBom;
        setLazyState(event);
    };

    const onFilter = (event: DataTableFilterEvent) => {
        event['first'] = 0;
        event['filter'] = globalFilter?.trim();
        event['isMissingSetup'] = isMissingSetup;
        event['isMissingBom'] = isMissingBom;        
        setLazyState(event);
    };

    const onSort = (event: DataTableStateEvent) => {
        setSortField(event.sortField);
        setSortOrder(event.sortOrder);
    };

    const styleExpanderTemplate = (rowData: Style) => {
        return (
            <Link className="pi pi-angle-right" to={`/styles/${rowData.styleCode}`}></Link>
        )
    }

    const styleCodeBodyTemplate = (rowData: Style) => {
        return rowData.styleCode;
    }

    const descriptionBodyTemplate = (rowData: Style) => {
        return rowData.description;
    }

    const companyBodyTemplate = (rowData: Style) => {
        return rowData.company;
    }

    const materialGroupBodyTemplate = (rowData: Style) => {
        return rowData.materialGroup;
    }

    const productHierarchy1BodyTemplate = (rowData: Style) => {
        return rowData.productHierarchyOne;
    }

    const productHierarchy2BodyTemplate = (rowData: Style) => {
        return rowData.productHierarchyTwo;
    }

    const productHierarchy3BodyTemplate = (rowData: Style) => {
        return rowData.productHierarchyThree;
    }

    const productCategoryBodyTemplate = (rowData: Style) => {
        return rowData.productCategory;
    }

    const productAllocationBodyTemplate = (rowData: Style) => {
        return rowData.productAllocation;
    }

    const effectiveDateBodyTemplate = (rowData: Style) => {
        return rowData.effectiveDate;
    }

    const styleStatusBodyTemplate = (rowData: Style) => {
        return rowData.styleStatus;
    }

    const showStylesMissingSetup = (e: CheckboxChangeEvent) => {
        let _lazyState = {...lazyState};

        if (e.checked) {
            _lazyState.isMissingSetup = true;
        } else {
            _lazyState.isMissingSetup = false;
        }

        setIsMissingSetup(e.checked as boolean);
        setLazyState(_lazyState);
    };

    const showStylesMissingBom = (e: CheckboxChangeEvent) => {
        let _lazyState = {...lazyState};

        if (e.checked) {
            _lazyState.isMissingBom = true;
        } else {
            _lazyState.isMissingBom = false;
        }

        setIsMissingBom(e.checked as boolean);
        setLazyState(_lazyState);
    };

    return (
        <div className="grid-nogutter">
            <div className="col-12">
                <Toast ref={toast} />

                <Card className="layout-main-card border-noround">
                    <Card className="mb-2 surface-100">
                        <div className="field grid -mb-2">
                            <label htmlFor="styleCodeSearch" className="ml-2 mr-3 -mt-1 font-bold">Style Code</label>
                            <div className="col-fixed mr-2">
                                <IconField iconPosition="left">
                                    <InputIcon className="pi pi-search" />
                                    <InputText ref={refStyleCode} id="styleCodeSearch" className="p-inputtext-sm" type="search" autoComplete="off" 
                                    onChange={(e) => setGlobalFilter((e.target as HTMLInputElement).value)} placeholder="Search..." />
                                </IconField>
                            </div>
                            <span className="field-checkbox mt-2">
                                <Checkbox inputId="isMissingSetup" name="option" checked={isMissingSetup} onChange={showStylesMissingSetup} />
                                <label htmlFor="isMissingSetup">Is Missing Setup</label>
                            </span>
                            <span className="field-checkbox mt-2 ml-4">
                                <Checkbox inputId="isMissingBom" name="option" checked={isMissingBom} onChange={showStylesMissingBom} />
                                <label htmlFor="isMissingBom">Is Missing Bill of Materials</label>
                            </span>
                        </div>
                    </Card>
                    
                    <DataTable lazy value={styles}
                        dataKey="rowNumber" size="small" rowHover={true} loading={loadingBillOfMaterialStyles} onSort={onSort} sortField={sortField} sortOrder={sortOrder}
                        scrollable scrollHeight="calc(100vh - 15.5rem)"
                        paginator alwaysShowPaginator={false} rowsPerPageOptions={[5, 10, 25]}
                        first={lazyState.first} rows={lazyState.rows} totalRecords={totalStyles}
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} styles."
                        onPage={onPage} onFilter={onFilter}
                        globalFilter={debouncedFilter} emptyMessage="No bill of materials found." >
                        <Column body={styleExpanderTemplate} style={{ width: '3em' }} />
                        <Column field="styleCode" filterField="style_Code" sortField='StyleCode' header="Style Code" body={styleCodeBodyTemplate} sortable align="center" alignHeader="center"></Column>
                        <Column field="description" filterField="description" sortField='Description' header="Description" body={descriptionBodyTemplate} sortable align="center" alignHeader="center"></Column>
                        <Column field="company" filterField="company" sortField='Company' header="Company" body={companyBodyTemplate} sortable align="center" alignHeader="center"></Column>
                        <Column field="materialGroup" filterField="materialGroup" sortField='MaterialGroup' header="Material Group" sortable body={materialGroupBodyTemplate} align="center" alignHeader="center"></Column>
                        <Column field="productHierarchyOne" filterField="productHierarchyOne" sortField='ProductHierarchy1' header="Product Hierarchy 1" sortable body={productHierarchy1BodyTemplate} align="center" alignHeader="center"></Column>
                        <Column field="productHierarchyTwo" filterField="productHierarchyTwo" sortField='ProductHierarchy2' header="Product Hierarchy 2" sortable body={productHierarchy2BodyTemplate} align="center" alignHeader="center"></Column>
                        <Column field="productHierarchyThree" filterField="productHierarchyThree" sortField='ProductHierarchy3' header="Product Hierarchy 3" sortable body={productHierarchy3BodyTemplate} align="center" alignHeader="center"></Column>
                        <Column field="productCategory" filterField="productCategory" sortField='ProductCategory' header="Product Category" sortable body={productCategoryBodyTemplate} align="center" alignHeader="center"></Column>
                        <Column field="productAllocation" filterField="productAllocation" sortField='ProductAllocation' header="Product Allocation" sortable body={productAllocationBodyTemplate} align="center" alignHeader="center"></Column>
                        <Column field="effectiveDate" filterField="effectiveDate" sortField='EffectiveDate' header="Effective Date" sortable body={effectiveDateBodyTemplate} align="center" alignHeader="center"></Column>
                        <Column field="styleStatus" filterField="styleStatus" sortField='styleStatus' header="Material Status" sortable body={styleStatusBodyTemplate} align="center" alignHeader="center"></Column>
                        <Column field="hasBom" header="Has BOM" style={{ display: 'none' }}></Column>
                    </DataTable>
                </Card>
            </div>
        </div>
    );
}

export default Styles;